import { IntentCRMExportEnum } from '../enums/intent-crm-export.enum';

export function crmExportValue(crm: string): string {
    return IntentCRMExportEnum[crm?.toUpperCase()] || '';
} 
